module.exports = __webpack_public_path__ + "static/casey-neistat-7ceda79f38b1ab1be083014581976d28.jpg";